import { useState } from "react";
import { useTranslation } from "react-i18next";
import { ResearchSummaryModal } from "./ResearchSummaryModal";

export const ResearchSummary = ({
  researchSummaryData,
  fetchData,
  isCurrentUserProfile,
}) => {
  const { t } = useTranslation();

  const [researchSummaryModal, setResearchSummaryModal] = useState(false);

  const toggleResearchSummaryModal = () => {
    setResearchSummaryModal((prev) => !prev);
  };
  return (
    <>
      <div className="p-4 rounded-lg border border-grey-200 bg-white d-flex flex-column gap-0">
        <div className="d-flex flex-wrap justify-content-between align-items-center column-gap-3 row-gap-2 mb-3">
          <h4 className="mb-0 text-md font-semibold text-grey-800">
            {t("auth.viewProfile.researchSummary")}
          </h4>
          {isCurrentUserProfile && (
            <div className="d-flex align-items-center gap-1">
              <button
                type="button"
                className="btn btn-gray-light font-medium rounded-lg d-inline-flex align-items-center gap-1"
                onClick={toggleResearchSummaryModal}
              >
                <i className="bx bx-pencil"></i> Edit
              </button>
            </div>
          )}
        </div>
        <div>
          {researchSummaryData ? (
            <span>{researchSummaryData}</span>
          ) : (
            <span className="text-grey-400">
              {t("auth.viewProfile.noresearchSummary")}
            </span>
          )}
        </div>
      </div>

      {researchSummaryModal && (
        <ResearchSummaryModal
          show={researchSummaryModal}
          researchSummaryData={researchSummaryData}
          toggle={toggleResearchSummaryModal}
          fetchData={fetchData}
        />
      )}
    </>
  );
};
